import {
  useDecodedToken,
  useIsAuthenticated,
  useIsFeatureWhitelisted,
} from 'mf_core/auth';
import { useApiQuery } from 'mf_core/query';
import { useLocation } from 'react-router-dom';

export const WIDGET_CONFIGURATIONS_PATH =
  '/account-management/v1/widget-configurations';

export const WIDGET_CONFIG_QUERY_KEY = [
  WIDGET_CONFIGURATIONS_PATH,
  undefined,
  undefined,
];

export type GetWidgetsResponseTO = {
  widgets: WidgetTO[];
};

export type WidgetTO = {
  dataName?: string;
  defId?: string;
  height?: string;
  icon?: string;
  id?: string;
  isDefaultConfiguration: boolean;
  isSelected: boolean;
  key: string;
  link?: string;
  openMode?: string;
  sequence: number;
  title?: string;
  type: 'PrimaryWidget' | 'SecondaryWidget';
  width?: string;
};

export function useGetWidgetConfig() {
  const isAuthenticated = useIsAuthenticated();
  const { pathname } = useLocation();
  const isFeatureWhitelisted = useIsFeatureWhitelisted();
  const isCmpWhitelisted = isFeatureWhitelisted('CMP');
  const enableWidgetConfigApi =
    isAuthenticated &&
    (!isCmpWhitelisted || pathname.toLowerCase().includes('/dashboard-old'));
  const decodedToken = useDecodedToken();
  const resellerProspect = decodedToken?.resellerProspect || false;
  const data = useApiQuery<GetWidgetsResponseTO>(
    WIDGET_CONFIGURATIONS_PATH,
    undefined,
    {
      enabled: enableWidgetConfigApi && !resellerProspect,
      queryKey: [WIDGET_CONFIGURATIONS_PATH],
      staleTime: Infinity,
    }
  );
  return data;
}
